import React from "react";
import styled from "styled-components";
import { Mail } from "lucide-react";
import { router } from "@inertiajs/react";

import { apiGet } from "../../../api";
import LeftSidebar from "../../components/left-sidebar";
import { AppLayout, FeedColumn, RightSidebar } from "../../constants/styles";
import TrendingPanel from "../../components/trending-panel";

const PageHeader = styled.div`
  padding: 1rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 {
    font-size: 1.25rem;
    font-weight: 700;
  }
`;
const ConvItem = styled.div`
  padding: 1rem;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  display: flex;
  gap: 0.75rem;
  align-items: center;
  &:hover {
    background: var(--hover-bg, rgba(0, 0, 0, 0.03));
  }
`;
const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--primary, #ff9900);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: 700;
  font-size: 1.125rem;
  flex-shrink: 0;
`;
const ConvInfo = styled.div`
  flex: 1;
  min-width: 0;
`;
const ConvName = styled.div`
  font-weight: 600;
  font-size: 0.9375rem;
`;
const ConvPreview = styled.div`
  font-size: 0.8125rem;
  color: var(--muted-foreground);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const ConvTime = styled.div`
  font-size: 0.75rem;
  color: var(--muted-foreground);
`;
const Badge = styled.div`
  background: var(--primary);
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.625rem;
  font-weight: 700;
`;
const Empty = styled.div`
  text-align: center;
  padding: 3rem;
  color: var(--muted-foreground);
  h3 {
    margin: 0.5rem 0;
  }
`;

export default function MessagesPage() {
  const [conversations, setConversations] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    apiGet("/api/v1/communities/conversations?perpage=50")
      .then((res) => {
        if (res.parsedResponse?.data) setConversations(res.parsedResponse.data);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <AppLayout>
      <LeftSidebar activePage="messages" />
      <FeedColumn>
        <PageHeader>
          <h1>Messages</h1>
        </PageHeader>
        {loading ? (
          <Empty>Loading...</Empty>
        ) : conversations.length === 0 ? (
          <Empty>
            <Mail size={48} />
            <h3>No messages yet</h3>
            <p>Send a direct message to start a conversation.</p>
          </Empty>
        ) : (
          conversations.map((c) => (
            <ConvItem
              key={c.id}
              onClick={() => router.visit(`/communities/messages/${c.id}`)}
            >
              <Avatar>{c.other_participant?.name?.charAt(0) || "?"}</Avatar>
              <ConvInfo>
                <ConvName>{c.other_participant?.name}</ConvName>
                <ConvPreview>
                  {c.last_message?.content || "No messages"}
                </ConvPreview>
              </ConvInfo>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  gap: "0.25rem",
                }}
              >
                {c.last_message && (
                  <ConvTime>
                    {new Date(c.last_message.created_at).toLocaleDateString()}
                  </ConvTime>
                )}
                {c.unread_count > 0 && <Badge>{c.unread_count}</Badge>}
              </div>
            </ConvItem>
          ))
        )}
      </FeedColumn>
      <RightSidebar>
        <TrendingPanel />
      </RightSidebar>
    </AppLayout>
  );
}
